import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'gnos-tooltip'

import cx from 'classnames'

import './style.scss'

export default class Distraints extends Component {
    static propTypes = {
        clickHandler: PropTypes.func,
        clickIdentifier: PropTypes.string.isRequired,
        distraintsActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        distraintsActiveMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        distraintsHistorical: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        distraintsHistoricalMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        distraintsPaidActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        headerMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        identifier: PropTypes.string.isRequired,
        noMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }

    handleOnClick = () => {
        const { clickHandler, clickIdentifier, distraintsActive, distraintsPaidActive, distraintsHistorical } =
            this.props

        if (clickHandler && (distraintsActive || distraintsPaidActive || distraintsHistorical)) {
            clickHandler(clickIdentifier)
        }
    }

    render() {
        const {
            noMessage,
            headerMessage,
            identifier,
            distraintsActive,
            distraintsPaidActive,
            distraintsHistorical,
            distraintsActiveMessage,
            distraintsHistoricalMessage,
            tooltip,
        } = this.props

        const content = (
            <div className={cx('indicator-item', 'indicator-section')}>
                <div className={'indicator-item-header'}>{headerMessage}</div>
                <div className={'indicator-content'} onClick={this.handleOnClick}>
                    <div
                        className={cx('indicators-image', {
                            'distraints-past': !distraintsActive && !distraintsPaidActive && distraintsHistorical,
                            'distraints-present': distraintsActive || distraintsPaidActive,
                            na: !distraintsActive && !distraintsPaidActive && !distraintsHistorical,
                        })}
                    />
                    <div className={'indicator-message'}>
                        {(distraintsActive || distraintsPaidActive) && distraintsActiveMessage}
                        {!distraintsActive &&
                            !distraintsPaidActive &&
                            distraintsHistorical &&
                            distraintsHistoricalMessage}
                        {!distraintsActive && !distraintsPaidActive && !distraintsHistorical && noMessage}
                    </div>
                    <div
                        className={cx(
                            'indicator-item-footer ',
                            (distraintsActive || distraintsPaidActive || distraintsHistorical) && 'magnifier'
                        )}
                    />
                </div>
            </div>
        )

        return tooltip ? (
            <Tooltip id={`indicator_tooltip_${identifier}`} content={tooltip} key={`indicator_tooltip_${identifier}`}>
                {content}
            </Tooltip>
        ) : (
            content
        )
    }
}
